import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.reduce";
import React from 'react';
export default function nanostyled(tag, styleProps) {
  var Component = function Component(props) {
    var _Object$keys$reduce = Object.keys(styleProps).reduce(function (memo, key) {
      var style = props[key] === undefined ? styleProps[key] : props[key];
      if (style) memo.css.push(style);
      delete memo.filteredProps[key];
      return memo;
    }, {
      css: [props.className].filter(Boolean),
      filteredProps: Object.assign({}, props)
    }),
        css = _Object$keys$reduce.css,
        filteredProps = _Object$keys$reduce.filteredProps;

    var passedProps = Object.assign(filteredProps, {
      className: css.join(' '),
      tag: undefined
    });
    return React.createElement(props.tag || tag, passedProps);
  };

  Component.displayName = "nanostyled-".concat(tag);
  return Component;
}